<template>
  <ul class="no-margin-y">
    <li v-for="(page, index) in pages" :key="index">
      <a :href="page.link">{{ page.title }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LinkedPages',
  props: {
    pages: {
      type: Array
    }
  }
}
</script>
